module.exports = "img/user-onboarding/WorkMessaging.2643669.png";